<template>
  <div class="fixed">
    <!-- 导航栏 -->
    <div class="nav-navigation flex flex-c bg-ff topppp" :class="new_nav ? 'on' : ''" id="topNav">
      <div class="flex">
        <router-link v-show="!new_nav" :to="{ path: '/index' }" class="flex-c nav-logo mr-20"><img
            src="../assets/logo_new.png" /></router-link>
        <router-link v-show="new_nav" :to="{ path: '/index' }" class="flex-c nav-logo mr-20"><img
            src="../assets/logo_new.png" /></router-link>
        <div class="titleeeeee" :class="{ 'white': new_nav }">

          <span v-show="typeName == 'xbcm'">星报传媒</span>
          <span v-show="typeName == 'hfwl'">合肥文旅</span>
          <span v-show="typeName == 'sutpk'">宿州图片库</span>
          <span v-show="typeName == 'hlwuhu'">欢乐芜湖</span>
          <span v-show="typeName == 'laswxcb'">六安市委宣传部</span>
          <span v-show="typeName == 'hfssq'">蜀山区图片库</span>
          <span v-show="typeName == 'hfjkq'">经开区图片库</span>
          <span v-show="typeName == 'hhsq'">海恒社区图片库</span>
          <!-- {{ typeName == "xbcm" ? '星报传媒' : typeName == "hfwl" ? '合肥文旅' : typeName == "sutpk" ? '宿州图片库' : typeName
            == "hlwuhu" ? '欢乐芜湖' :
            typeName
              == "laswxcb" ? '六安市委宣传部' : "黄山市委宣传部" }} -->
        </div>
      </div>

      <div class="flex rightttttt">
        <div class="nav-list  flex flex-c">

          <div v-for="item, index in nav_list" :key="item.id" class="flex-c f-14 relative"
            @mouseenter="navMouse(index, true)" @mouseleave="navMouse(index, false)"
            @click.stop="bindlinkTo(index, item)">
            <span>{{ item.name }}</span>

            <!-- 	<div v-show="item.z_list.length" :class="[item.isShow?'isShow':'', item.z_list.length>6?'':'nav-z-list-active']" class="absolute nav-z-list bg-ff">
												<div  v-for="x in item.z_list" :key="x.id" @click.stop="bindlinkTo(x.url,x.name)">{{x.name}} </div>
										</div> -->
          </div>

          <!-- <div v-show="typeName == 'hfwl'" class="flex-c f-14 relative">
            <span @click.stop="bindlinkTo('11', { 'url': '/video_list_hfwl', name: '视频', typeName: 'hfwl' })">视频</span>
          </div>
          <div v-show="typeName == 'hfwl'" class="flex-c f-14 relative">
            <span
              @click.stop="bindlinkTo('11', { 'url': '/special_list_hfwl', name: '专题', typeName: 'hfwl' })">专题</span>
          </div> -->
          <!-- 		<div class="flex-c f-14 relative" @mouseenter="aboutMouse(true)" @mouseleave="aboutMouse(false)">
										<span  @click.stop="bindlinkTo('/about?id=' + about_list[0].id,about_list[0].SYS_TOPIC)" >关于我们</span>
								
										<div :class="showAbout?'isShow':''" class="absolute nav-z-list bg-ff nav-z-list-active">
												<div  v-for="x in about_list" :key="x.id" @click.stop="bindlinkTo('/about?id=' + x.id,x.SYS_TOPIC)">{{x.SYS_TOPIC}} </div>
										</div>
								</div > -->
        </div>
        <div class="flex-c ml-50" v-show="isLogin == 0">
          <router-link to="/register" class="flex-c nav-login f-16 c-33">登录</router-link>
          <router-link to="/register" class="flex-c nav-login f-16 c-33 ml-15">注册</router-link>
        </div>
        <router-link to="/userIndex" class="flex-c ml-20 shou" v-show="isLogin == 1">
          <img v-if="picture" class="user-head mr-20" :src="picture" alt="" />
          <img v-else class="user-head mr-20" src="../assets/images/noface.gif" alt="" />
          <span class="f-14 " :class="!new_nav ? 'c-ff' : 'c-33'">{{ username }}</span>
        </router-link>
        <div class="flex-c ml-20" v-show="isLogin == 1">
          <router-link to="/userAuth" class="flex-c nav-login f-16 c-33"
            v-show="authorStatus === null">作者认证</router-link>
          <div @click="quitLogin" class="flex-c nav-login f-16 c-33 ml-15">退出登录</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      nav_list: [], // 导航栏列表
      // new_nav: false,
      isLogin: 0,
      picture: '',
      username: '',
      about_list: [],
      showAbout: false,
      authorStatus: 0,
      pic_cates: [],
      typeName: '',
    }
  },
  props: {
    new_nav: {
      type: Boolean
    }
  },
  computed: {
    routerName() {
      return this.$route.name
    }
  },
  created() {
    // console.log(this.$route);
    if (this.$route.query.type == 'xbcm' || this.$route.name == 'xbcm') {
      this.typeName = 'xbcm'
    } else if (this.$route.query.type == 'hfwl' || this.$route.name == 'hfwl') {
      this.typeName = 'hfwl'
    } else if (this.$route.query.type == 'sutpk' || this.$route.name == 'sutpk') {
      this.typeName = 'sutpk'
    } else if (this.$route.query.type == 'hlwuhu' || this.$route.name == 'hlwuhu') {
      this.typeName = 'hlwuhu'
    } else if (this.$route.query.type == 'hhsq' || this.$route.name == 'hhsq') {
      this.typeName = 'hhsq'
    } else if (this.$route.query.type == 'hfssq' || this.$route.name == 'hfssq') {
      this.typeName = 'hfssq'
    } else if (this.$route.query.type == 'hfjkq' || this.$route.name == 'hfjkq') {
      this.typeName = 'hfjkq'
    } else {
      this.typeName = ''
    }



    this.bindNavlist() // 获取导航栏
    // this.bindCaterec()
  },

  mounted() {

    // 监听页面滚动
    window.addEventListener('scroll', this.scrollToTop)
    this.checkToken()
    this.bindBottom()
  },


  methods: {

    // 跳转
    bindlinkTo(index, item) {

      // this.$emit("clickTop",index)
      console.log(item);
      if (item.url == '/index') {
        this.$router.push({ path: item.url, query: { name: item.name } })
      } else {

        let link = this.$router.resolve({
          path: item.url, //要跳转的路由
          query: {
            name: item.name,
            type: this.typeName
          }
        });
        window.open(link.href, "_blank"); //打开新窗口
      }
      // this.$router.resolve({
      // 	path: item.url,
      // 	query: {name:item.name}
      // })
    },
    async bindCaterec() {
      let _this = this;
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 135 }, { pub_sale_status: 1 }]),
        orderBy: 'pub_a_order asc pub_lastmodified desc id asc',
        pageNo: 1,
        pageSize: 15,
        searchText: ''
      };
      const res = await _this.post('/spc/cms/publish/list.do', data);
      if (res.success) {
        res.result.forEach(x => {
          let index = x.DOC_SOURCEURL.indexOf('?');
          x.params = x.DOC_SOURCEURL.substr(index + 1);
        });
        _this.pic_cates = res.result;

      } else {
        _this.$Message.error(res.description);
      }

    },


    quitLogin() {
      let _this = this
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('picture')
      localStorage.removeItem('authorStatus')
      _this.$router.replace({ path: '/register' })
    },

    // 验证token的时效性
    async checkToken() {
      // 验证token的时效性
      let _this = this
      const tokenState = await this.util.checkToken(localStorage.getItem('token'))
      if (tokenState.result == 0) {
        localStorage.removeItem('picture')
        localStorage.removeItem('username')
        localStorage.removeItem('id')
        localStorage.removeItem('loginName')
        return
      }
      _this.isLogin = tokenState.result - 0
      _this.picture = tokenState.data.picture
      _this.username = tokenState.data.username || tokenState.data.nickName
      _this.authorStatus = tokenState.data.authorStatus
      localStorage.setItem('picture', _this.picture)
      localStorage.setItem('id', tokenState.data.id)
      localStorage.setItem('username', _this.username)
      localStorage.setItem('loginName', tokenState.data.loginName)
      localStorage.setItem('authorStatus', _this.authorStatus)
    },

    // 获取尾部关于我们部分
    async bindBottom() {
      let _this = this
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 82 }, { pub_sale_status: 1 }]),
        orderBy: "pub_a_order asc pub_lastmodified desc id asc",
        pageNo: 1,
        pageSize: 15,
        searchText: "",
      }
      const res = await _this.post('/spc/cms/publish/list.do', data)
      if (res.success) {
        _this.about_list = res.result
      } else {
        _this.$Message.error(res.description);
      }
    },

    // 获取导航列表
    async bindNavlist() {
      let _this = this
      const res = await _this.get('/spc/cms/col/getAllColBySiteId.do', { siteId: 101, chId: 35 })
      // console.log(res);
      if (res.success) {
        console.log(res.data, 999)
        res.data.forEach(element => {
          if (element.pId == 227) {
            console.log(element, '导航数据')
          }
        });
        let idd = ''
        if (this.typeName == 'xbcm') {
          idd = 147
        } else if (this.typeName == 'hfwl') {
          idd = 157
        } else if (this.typeName == 'laswxcb') {
          idd = 167
        } else if (this.typeName == 'sutpk') {
          idd = 240
        } else if (this.typeName == 'hlwuhu') {
          idd = 227
        } else if (this.typeName == 'hfssq') {
          idd = 198573
        } else if (this.typeName == 'hfjkq') {
          idd = 198578
        } else if (this.typeName == 'hhsq') {
          idd = 198583
        } else {
          idd = 135
        }
        _this.nav_list = res.data.filter(x => x.pId == idd)
        let arr = _this.nav_list
        _this.nav_list = arr
        console.log(arr, _this.nav_list, '导航数据')
      } else {
        _this.$Message.error(res.message);
      }
      // console.log(111111,this.nav_list);

      // _this.$Spin.show()
    },

    // 显示与否-子导航
    navMouse(index, state) {
      let _this = this
      let obj = _this.nav_list[index]
      obj.isShow = state
      _this.nav_list.splice(index, 1, obj)

    },
    // 显示与否-子导航
    aboutMouse(state) {
      let _this = this
      _this.showAbout = state

    },

  }

}
</script>

<style lang="less" scoped>
.white {
  color: #333333 !important;
}

.titleeeeee {
  font-size: 24px;
  // color: #FFFFFF;
  color: #333333;
  font-family: 楷体;
  padding: 10px 0 0 0;
  font-weight: 600;
}

.rightttttt {
  // margin-left: 400px;
}

.topppp {
  display: flex;
  justify-content: space-around;
  padding: 0 200px !important;
}

div.fixed {
  top: 0;
  z-index: 1000;
  width: 100%;
}

/* 导航栏部分 */
.nav-title {
  background-color: #f67524;
  height: 40px;
  padding-right: 200px;
}

.nav-navigation {
  min-width: 1350px;
  padding: 0 !important;
  margin: 0 auto;
  height: 85px;
  // background: rgba(28, 35, 39, 0.7);
  background: #fff;

  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
}

.nav-navigation.on {
  background: rgba(255, 255, 255, 1);
}

.nav-navigation.on .nav-list .relative {
  color: #333;
}

.nav-list {
  cursor: pointer;

  .relative::after {
    position: absolute;
    content: '';
    bottom: 0;
    width: 0;
    transition: all .4s;
    left: 0;
    height: 2px;
    background: orangered;
  }

  .relative:hover::after {
    width: 100%;
  }
}

.nav-logo {
  width: 183px;
  height: 50px;

  img {
    width: 100%;
    height: 100%;
  }
}

.nav-login {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  background: #00a1d6;
  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
  color: #fff !important;
  font-size: 12px;
  border-radius: 4px;
  transition: all 0.2s;
  border: none;
}

.nav-login:hover {
  color: #333 !important;
}

.nav-list>div {
  padding: 0 15px;
  height: 50px;
}

.nav-list .relative {
  font-size: 16px;
  // color: #fff;
  color: #333;
}

// 新优化规则 子导航
.nav-z-list {
  left: 50%;
  transform: translateX(-50%);
  top: 50px;
  border-radius: 0px !important;
  text-align: center;
  min-width: 90px;
  transition: all .5s;
  // overflow: hidden;
  opacity: 0;
  max-height: 0;
  color: #666;
  font-size: 14px;
  padding: 0;
  // height: 240px;
  overflow-y: scroll;
}

.nav-z-list.isShow {
  opacity: 1;
  max-height: 240px;
}

.nav-z-list>div {
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  margin-top: 0 !important;
  transition: all .4s;
}

.nav-z-list>div:first-child {
  margin-top: 0;
}

.nav-z-list>div:hover {
  background-color: #21A0CA;
  color: #fff;
}

// 用户信息
.user-head {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.nav-z-list-active::-webkit-scrollbar {
  width: 0 !important;
}

.nav-z-list-active::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
